core.service('formUtils', [
    function () {
        this.getAllFields = function (form) {
            var result = [];
            _.forEach(form, function(property) {
                if (_.isObject(property) && property.hasOwnProperty('$modelValue')) {
                    result.push(property);
                }
            });
            return result;
        };

        this.getAllDirtyFields = function (form) {
            var result = [];
            _.forEach(form, function(property) {
                if (_.isObject(property) && property.hasOwnProperty('$modelValue') && property.hasOwnProperty('$dirty') && property.$dirty) {
                    result.push(property);
                }
            });
            return result;
        };
    }
]);
